
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

class NewCartDrawer extends HTMLElement {
  constructor() {
    super();

    this.drawer = this;

    this.cartButton = document.querySelector("#cart-button");
    this.overlay = this.querySelector(".new-cart-drawer__overlay");
    this.closeButton = this.querySelector(".new-cart-drawer__close-btn");
    this.copyBtn = this.querySelectorAll(
      ".new-cart-drawer__available-offers-code-copy-btn"
    );

    this.cartButton.addEventListener("click", (event) => {
      event.preventDefault();
      this.open();
    });

    this.copyBtn.forEach((button) => {
      button.addEventListener("click", () => {
        const couponCode = button.previousElementSibling.textContent.trim();

        navigator.clipboard
          .writeText(couponCode)
          .then(() => {
            button.textContent = "Copied!";
            button.classList.add("copied");

            setTimeout(() => {
              button.textContent = "Copy Code";
              button.classList.remove("copied");
            }, 2000);
          })
          .catch((err) => {
            console.error("Failed to copy: ", err);
          });
      });
    });

    this.overlay.addEventListener("click", () => {
      this.close();
    });
    this.closeButton.addEventListener("click", () => {
      this.close();
    });

    document.querySelectorAll(".quick-product__btn").forEach((quickAdd) => {
      quickAdd.addEventListener("click", () => {
        this.updateCart(quickAdd.dataset.variantId, 1);
      });
    });
  }

  open() {
    this.drawer.classList.add("open");
    document.body.style.overflow = "hidden";
  }

  close() {
    this.drawer.classList.remove("open");
    document.body.style.overflow = "auto";
  }

  shouldOpenStickyDrawer() {
    const body = document.body;

    const isHomeOrCollection =
      body.classList.contains("template-index") ||
      body.classList.contains("template-collection");

    const isStickyEnabled =
      body.getAttribute("data-sticky_view_cart") === "true";

    return isHomeOrCollection && isStickyEnabled;
  }

  openStickyDrawer() {
    const stickyDrawer = document.querySelector(".sticky-view-cart");
    if (stickyDrawer) {
      document.body.style.marginBottom = "172px";
    }
  }

  async updateCart(
    newId,
    quantity = 1,
    body,
    formData = false,
    button = null
  ) {
    let addBody, config;

    const buttonSpinner = button?.querySelector(".loading__spinner");
    const buttonLabel = button?.querySelector(".new-cart-drawer__btn-label");

    // Show gift overlay loader at the start
    const giftOverlay = document.querySelector(".gift__overlay");
    if (giftOverlay) {
      giftOverlay.classList.remove("hidden");
    }

    if (formData) {
      config = fetchConfig("javascript");
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];
      addBody = body;

      addBody.append(
        "sections",
        this.getSectionsToRender().map((section) => section.section)
      );
      addBody.append("sections_url", window.location.pathname);
    } else {
      config = fetchConfig();

      if (body) {
        addBody = JSON.stringify({
          items: body,
          sections: this.getSectionsToRender().map(
            (section) => section.section
          ),
          sections_url: window.location.pathname,
        });
      } else {
        addBody = JSON.stringify({
          items: [
            {
              id: parseInt(newId, 10),
              quantity: parseInt(quantity, 10),
            },
          ],
          sections: this.getSectionsToRender().map(
            (section) => section.section
          ),
          sections_url: window.location.pathname,
        });
      }
    }

    try {
      const response = await fetch(`${theme.routes.cartAdd}`, {
        ...config,
        body: addBody,
      });
      const state = await response.text();
      const outerParsedState = JSON.parse(state);

      const cartResponse = await fetch("/cart.js");
      const cartState = await cartResponse.text();
      const parsedState = JSON.parse(cartState);

      this.classList.toggle("is-empty", parsedState.item_count === 0);
      const cartDrawerWrapper = document.querySelector(".new-cart-drawer");
      const cartFooter = this.querySelector(".new-cart-drawer__footer");

      if (cartFooter)
        cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
      if (cartDrawerWrapper)
        cartDrawerWrapper.classList.toggle(
          "is-empty",
          parsedState.item_count === 0
        );

      const itemArray = parsedState.items;

      // Get gift IDs only (removed bundle logic)
      const giftIds = [
        this.dataset.firstGiftId
          ? parseInt(this.dataset.firstGiftId, 10)
          : null,
        this.dataset.secondGiftId
          ? parseInt(this.dataset.secondGiftId, 10)
          : null,
        this.dataset.thirdGiftId
          ? parseInt(this.dataset.thirdGiftId, 10)
          : null,
      ].filter((id) => id !== null && !isNaN(id));

      let nonFreebieCount = 0;
      let firstGiftFlag = false;
      let secondGiftFlag = false;
      let thirdGiftFlag = false;
      let firstGiftKey;
      let secondGiftKey;
      let thirdGiftKey;

      itemArray.forEach((item) => {
        // Count non-freebie items (excluding only gifts)
        if (!giftIds.includes(item.variant_id)) {
          nonFreebieCount += item.quantity;
        }

        // Check for existing gifts - only check if gift ID exists and is valid
        if (
          this.dataset.firstGiftId &&
          item.variant_id === parseInt(this.dataset.firstGiftId, 10)
        ) {
          firstGiftFlag = true;
          firstGiftKey = item.key;
        }

        if (
          this.dataset.secondGiftId &&
          item.variant_id === parseInt(this.dataset.secondGiftId, 10)
        ) {
          secondGiftFlag = true;
          secondGiftKey = item.key;
        }

        if (
          this.dataset.thirdGiftId &&
          item.variant_id === parseInt(this.dataset.thirdGiftId, 10)
        ) {
          thirdGiftFlag = true;
          thirdGiftKey = item.key;
        }
      });

      let giftChanged = false;
      let updateParsedState;

      // Gift logic based on quantity
      if (nonFreebieCount >= 4) {
        console.log("Adding all three gifts", nonFreebieCount);
        // Add all three gifts
        let itemsToAdd = [];

        if (!firstGiftFlag && this.dataset.firstGiftId) {
          itemsToAdd.push({
            id: parseInt(this.dataset.firstGiftId, 10),
            quantity: 1,
          });
        }

        if (!secondGiftFlag && this.dataset.secondGiftId) {
          itemsToAdd.push({
            id: parseInt(this.dataset.secondGiftId, 10),
            quantity: 1,
          });
        }

        if (!thirdGiftFlag && this.dataset.thirdGiftId) {
          itemsToAdd.push({
            id: parseInt(this.dataset.thirdGiftId, 10),
            quantity: 1,
          });
        }

        if (itemsToAdd.length > 0) {
          updateParsedState = this.processRequest("add", itemsToAdd);
          giftChanged = true;
        }
      } else if (nonFreebieCount >= 3) {
        // Add first two gifts, remove third if exists
        let itemsToAdd = [];

        if (!firstGiftFlag && this.dataset.firstGiftId) {
          itemsToAdd.push({
            id: parseInt(this.dataset.firstGiftId, 10),
            quantity: 1,
          });
        }

        if (!secondGiftFlag && this.dataset.secondGiftId) {
          itemsToAdd.push({
            id: parseInt(this.dataset.secondGiftId, 10),
            quantity: 1,
          });
        }

        if (itemsToAdd.length > 0) {
          updateParsedState = this.processRequest("add", itemsToAdd);
          giftChanged = true;
        }

        // Remove third gift if it exists
        if (thirdGiftFlag && this.dataset.thirdGiftId) {
          updateParsedState = this.processRequest(
            "change",
            parseInt(this.dataset.thirdGiftId, 10),
            thirdGiftKey
          );
          giftChanged = true;
        }
      } else if (nonFreebieCount >= 2) {
        // Add first gift only, remove second and third if they exist
        if (!firstGiftFlag && this.dataset.firstGiftId) {
          let items = [
            {
              id: parseInt(this.dataset.firstGiftId, 10),
              quantity: 1,
            },
          ];

          updateParsedState = this.processRequest("add", items);
          giftChanged = true;
        }

        // Remove second gift if it exists
        if (secondGiftFlag && this.dataset.secondGiftId) {
          updateParsedState = this.processRequest(
            "change",
            parseInt(this.dataset.secondGiftId, 10),
            secondGiftKey
          );
          giftChanged = true;
        }

        // Remove third gift if it exists
        if (thirdGiftFlag && this.dataset.thirdGiftId) {
          updateParsedState = this.processRequest(
            "change",
            parseInt(this.dataset.thirdGiftId, 10),
            thirdGiftKey
          );
          giftChanged = true;
        }
      } else {
        // Remove all gifts if quantity is less than 2
        let updates = {};
        let hasGiftsToRemove = false;

        if (firstGiftFlag && this.dataset.firstGiftId) {
          updates[firstGiftKey] = 0;
          hasGiftsToRemove = true;
        }

        if (secondGiftFlag && this.dataset.secondGiftId) {
          updates[secondGiftKey] = 0;
          hasGiftsToRemove = true;
        }

        if (thirdGiftFlag && this.dataset.thirdGiftId) {
          updates[thirdGiftKey] = 0;
          hasGiftsToRemove = true;
        }

        if (hasGiftsToRemove) {
          updateParsedState = this.processRequest("update", updates);
          giftChanged = true;
        }
      }

      if (!giftChanged) {
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            outerParsedState.sections[section.section],
            section.selector
          );
        });
        // Hide loader after UI update when no gifts changed
        if (giftOverlay) {
          giftOverlay.classList.add("hidden");
        }
      } else {
        // Wait for gift processing to complete
        const giftResult = await updateParsedState;
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            giftResult.sections[section.section],
            section.selector
          );
        });
        // Hide loader after UI update when gifts were processed
        if (giftOverlay) {
          giftOverlay.classList.add("hidden");
        }
      }
    } catch (error) {
      this.querySelectorAll(".loading__spinner").forEach((overlay) =>
        overlay.classList.add("hidden")
      );
      // Hide loader on error
      if (giftOverlay) {
        giftOverlay.classList.add("hidden");
      }
      console.log(error);
    } finally {
      if (buttonLabel && buttonSpinner) {
        buttonLabel.classList.remove("hidden");
        buttonSpinner.classList.add("hidden");
      }

      if (!this.drawer.classList.contains("open")) {
        if (this.shouldOpenStickyDrawer() && window.innerWidth <= 990) {
          this.openStickyDrawer();
        } else {
          this.open();
        }
      }
    }
  }

  async processRequest(requestType, items, key) {
    let body, fetchUrl;

    if (requestType == "add") {
      body = JSON.stringify({
        items: items,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });
      fetchUrl = theme.routes.cartAdd;
    } else if (requestType == "change") {
      body = JSON.stringify({
        id: key,
        quantity: 0,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });
      fetchUrl = theme.routes.cartChange;
    } else if (requestType == "update") {
      body = JSON.stringify({
        updates: items,
        quantity: 0,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });
      fetchUrl = theme.routes.cartUpdate;
    }

    let ps = await fetch(`${fetchUrl}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        return parsedState;
      })
      .catch((error) => {
        console.log(error);
      });

    return ps;
  }

  getSectionsToRender() {
    return [
      {
        id: "NewCartDrawer",
        section: "new-cart-drawer",
        selector: ".new-cart-drawer__main",
      },
      {
        id: "NewCartDrawer",
        section: "new-cart-drawer",
        selector: ".new-cart-drawer__heading",
      },
      {
        id: "sticky-view-cart",
        section: "sticky-view-cart",
        selector: ".sticky-view-cart",
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
}
customElements.define("new-cart-drawer", NewCartDrawer);

class NewCartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.removeItem();
    });
  }

  async removeItem() {
    const qtySelector = document.querySelector(
      `#quantity-selector--${this.dataset.qtyId}`
    );
    
    if (!qtySelector) {
      console.error('Quantity selector not found');
      return;
    }

    this.enableLoading();
    
    // Show gift overlay loader when gift processing might occur
    const giftOverlay = document.querySelector(".gift__overlay");
    if (giftOverlay) {
      giftOverlay.classList.remove("hidden");
    }

    const body = JSON.stringify({
      id: this.dataset.lineId,
      quantity: 0,
      sections: qtySelector.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    try {
      const response = await fetch(`${theme.routes.cartChange}`, { 
        ...fetchConfig(), 
        ...{ body } 
      });
      
      const text = await response.text();
      const parsedState = JSON.parse(text);

      // Re-calculate the entire cart state after removal
      await this.recalculateGifts(parsedState, qtySelector);
      
    } catch (error) {
      console.log('Error removing item:', error);
      this.querySelectorAll(".loading__spinner").forEach((overlay) =>
        overlay.classList.add("hidden")
      );
      // Hide loader on error
      if (giftOverlay) {
        giftOverlay.classList.add("hidden");
      }
    }

    this.disableLoading();
  }

  async recalculateGifts(parsedState, qtySelector) {
    const giftOverlay = document.querySelector(".gift__overlay");
    
    qtySelector.classList.toggle("is-empty", parsedState.item_count === 0);
    const cartDrawerWrapper = document.querySelector(".new-cart-drawer");
    const cartFooter = qtySelector.querySelector(".new-cart-drawer__footer");

    if (cartFooter)
      cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
    if (cartDrawerWrapper)
      cartDrawerWrapper.classList.toggle("is-empty", parsedState.item_count === 0);

    const itemArray = parsedState.items;

    // Calculate non-freebie count - filter out empty gift IDs and handle undefined
    const freebieIds = [
      qtySelector.dataset.firstGiftId ? parseInt(qtySelector.dataset.firstGiftId, 10) : null,
      qtySelector.dataset.secondGiftId ? parseInt(qtySelector.dataset.secondGiftId, 10) : null,
      qtySelector.dataset.thirdGiftId ? parseInt(qtySelector.dataset.thirdGiftId, 10) : null
    ].filter(id => id !== null && !isNaN(id));

    let nonFreebieCount = 0;
    let existingGifts = {
      first: { exists: false, key: null },
      second: { exists: false, key: null },
      third: { exists: false, key: null }
    };

    itemArray.forEach((item) => {
      // Count non-freebie items
      if (!freebieIds.includes(item.variant_id)) {
        nonFreebieCount += item.quantity;
      }

      // Check for existing gifts
      if (qtySelector.dataset.firstGiftId && item.variant_id === parseInt(qtySelector.dataset.firstGiftId, 10)) {
        existingGifts.first = { exists: true, key: item.key };
      }
      if (qtySelector.dataset.secondGiftId && item.variant_id === parseInt(qtySelector.dataset.secondGiftId, 10)) {
        existingGifts.second = { exists: true, key: item.key };
      }
      if (qtySelector.dataset.thirdGiftId && item.variant_id === parseInt(qtySelector.dataset.thirdGiftId, 10)) {
        existingGifts.third = { exists: true, key: item.key };
      }
    });

    // Determine what gifts should be present based on quantity
    const shouldHaveGifts = {
      first: nonFreebieCount >= 2 && qtySelector.dataset.firstGiftId,
      second: nonFreebieCount >= 3 && qtySelector.dataset.secondGiftId,
      third: nonFreebieCount >= 4 && qtySelector.dataset.thirdGiftId
    };

    // Build operations to sync cart with desired state
    let itemsToAdd = [];
    let itemsToRemove = {};
    let hasChanges = false;

    // Check first gift
    if (shouldHaveGifts.first && !existingGifts.first.exists) {
      itemsToAdd.push({
        id: parseInt(qtySelector.dataset.firstGiftId, 10),
        quantity: 1,
      });
      hasChanges = true;
    } else if (!shouldHaveGifts.first && existingGifts.first.exists) {
      itemsToRemove[existingGifts.first.key] = 0;
      hasChanges = true;
    }

    // Check second gift
    if (shouldHaveGifts.second && !existingGifts.second.exists) {
      itemsToAdd.push({
        id: parseInt(qtySelector.dataset.secondGiftId, 10),
        quantity: 1,
      });
      hasChanges = true;
    } else if (!shouldHaveGifts.second && existingGifts.second.exists) {
      itemsToRemove[existingGifts.second.key] = 0;
      hasChanges = true;
    }

    // Check third gift
    if (shouldHaveGifts.third && !existingGifts.third.exists) {
      itemsToAdd.push({
        id: parseInt(qtySelector.dataset.thirdGiftId, 10),
        quantity: 1,
      });
      hasChanges = true;
    } else if (!shouldHaveGifts.third && existingGifts.third.exists) {
      itemsToRemove[existingGifts.third.key] = 0;
      hasChanges = true;
    }

    // Execute changes
    if (hasChanges) {
      let finalState = parsedState;

      // First remove unwanted gifts
      if (Object.keys(itemsToRemove).length > 0) {
        finalState = await qtySelector.processRequest("update", itemsToRemove);
      }

      // Then add needed gifts
      if (itemsToAdd.length > 0) {
        finalState = await qtySelector.processRequest("add", itemsToAdd);
      }

      // Update UI with final state
      qtySelector.getSectionsToRender().forEach((section) => {
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) ||
          document.getElementById(section.id);
        elementToReplace.innerHTML = qtySelector.getSectionInnerHTML(
          finalState.sections[section.section],
          section.selector
        );
      });
    } else {
      // No gift changes needed, just update UI with current state
      qtySelector.getSectionsToRender().forEach((section) => {
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) ||
          document.getElementById(section.id);
        elementToReplace.innerHTML = qtySelector.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );
      });
    }

    // Hide gift overlay loader after all processing is complete
    if (giftOverlay) {
      giftOverlay.classList.add("hidden");
    }
  }

  enableLoading() {
    const cartDrawerItems = document.querySelector(
      ".new-cart-drawer__scroll-container"
    );
    cartDrawerItems?.classList.add("cart__items--disabled");

    let id = this.dataset.lineId.split(":");

    const cartItemElements = cartDrawerItems?.querySelectorAll(
      `#new-cart-item-${id[0]} .loading__spinner`
    );

    cartItemElements?.forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.checkOutContainer = document.querySelector(
      ".new-cart-drawer__checkout-container"
    );

    if (this.checkOutContainer) {
      const buttons = this.checkOutContainer.querySelectorAll("button");
      buttons.forEach((button) => {
        button.disabled = true;
        button.style.cursor = "not-allowed";
      });
    }
  }

  disableLoading() {
    const cartDrawerItems = document.querySelector(
      ".new-cart-drawer__scroll-container"
    );
    cartDrawerItems?.classList.remove("new-cart-drawer--disabled");

    let id = this.dataset.lineId.split(":");

    const cartItemElements = cartDrawerItems?.querySelectorAll(
      `#new-cart-item-${id[0]} .loading__spinner`
    );

    cartItemElements?.forEach((overlay) => overlay.classList.add("hidden"));

    this.checkOutContainer = document.querySelector(
      ".new-cart-drawer__checkout-container"
    );

    if (this.checkOutContainer) {
      const buttons = this.checkOutContainer.querySelectorAll("button");
      buttons.forEach((button) => {
        button.disabled = false;
        button.style.cursor = "pointer";
      });
    }
  }
}

customElements.define("new-cart-remove-button", NewCartRemoveButton);

class QuantitySelector extends HTMLElement {
  constructor() {
    super();

    this.inputField = this.querySelector(
      ".new-cart-drawer__cart-item-quantity-selector--input"
    );
    this.minusButton = this.querySelector(
      ".new-cart-drawer__cart-item-quantity-selector--minus"
    );
    this.plusButton = this.querySelector(
      ".new-cart-drawer__cart-item-quantity-selector--plus"
    );
    this.lineId = this.dataset.lineId;
    this.quantity = parseInt(this.inputField.value, 10);

    this.minusButton.addEventListener("click", (event) => {
      event.preventDefault();
      this.changeQuantity("minus");
    });
    this.plusButton.addEventListener("click", (event) => {
      event.preventDefault();
      this.changeQuantity("plus");
    });

    this.inputField.addEventListener("change", (event) => {
      event.preventDefault();
      this.changeQuantity("input", event.target.value);
    });
  }

  changeQuantity(operation, value) {
    if (
      operation === "minus" &&
      parseInt(this.inputField.value, 10) > parseInt(this.inputField.min, 10)
    ) {
      this.quantity--;
      this.updateCart(this.dataset.lineId, this.quantity);
    } else if (operation === "plus") {
      if (this.inputField.max) {
        if (
          parseInt(this.inputField.value, 10) <
          parseInt(this.inputField.max, 10)
        ) {
          this.quantity++;
          this.updateCart(this.dataset.lineId, this.quantity);
        }
      } else {
        this.quantity++;
        this.updateCart(this.dataset.lineId, this.quantity);
      }
    } else if (operation === "input") {
      this.updateCart(this.dataset.lineId, value);
    }
  }

  async processRequest(requestType, items, key) {
    let body, fetchUrl;

    if (requestType == "add") {
      body = JSON.stringify({
        items: items,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });
      fetchUrl = theme.routes.cartAdd;
    } else if (requestType == "change") {
      body = JSON.stringify({
        id: key,
        quantity: 0,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });
      fetchUrl = theme.routes.cartChange;
    } else if (requestType == "update") {
      body = JSON.stringify({
        updates: items,
        quantity: 0,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });
      fetchUrl = theme.routes.cartUpdate;
    }

    let ps = await fetch(`${fetchUrl}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        return parsedState;
      })
      .catch((error) => {
        console.log(error);
      });

    return ps;
  }

  async updateCart(line, quantity) {
    this.enableLoading(line);
    
    // Show gift overlay loader when gift processing might occur
    const giftOverlay = document.querySelector(".gift__overlay");
    if (giftOverlay) {
      giftOverlay.classList.remove("hidden");
    }

    const body = JSON.stringify({
      id: line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    try {
      const response = await fetch(`${theme.routes.cartChange}`, { ...fetchConfig(), ...{ body } });
      const state = await response.text();
      const parsedState = JSON.parse(state);

      this.classList.toggle("is-empty", parsedState.item_count === 0);
      const cartDrawerWrapper = document.querySelector(".new-cart-drawer");
      const cartFooter = this.querySelector(".new-cart-drawer__footer");

      if (cartFooter)
        cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
      if (cartDrawerWrapper)
        cartDrawerWrapper.classList.toggle(
          "is-empty",
          parsedState.item_count === 0
        );

      const itemArray = parsedState.items;

      // Calculate non-freebie count - filter out empty gift IDs and handle undefined
      const freebieIds = [
        this.dataset.firstGiftId ? parseInt(this.dataset.firstGiftId, 10) : null,
        this.dataset.secondGiftId ? parseInt(this.dataset.secondGiftId, 10) : null,
        this.dataset.thirdGiftId ? parseInt(this.dataset.thirdGiftId, 10) : null
      ].filter(id => id !== null && !isNaN(id));

      let nonFreebieCount = 0;
      let firstGiftFlag = false;
      let secondGiftFlag = false;
      let thirdGiftFlag = false;
      let firstGiftKey;
      let secondGiftKey;
      let thirdGiftKey;
      let giftChanged = false;
      let updateParsedState;

      itemArray.forEach((item) => {
        // Count non-freebie items
        if (!freebieIds.includes(item.variant_id)) {
          nonFreebieCount += item.quantity;
        }

        // Check for existing gifts - only check if gift ID exists and is valid
        if (this.dataset.firstGiftId && item.variant_id === parseInt(this.dataset.firstGiftId, 10)) {
          firstGiftFlag = true;
          firstGiftKey = item.key;
        }

        if (this.dataset.secondGiftId && item.variant_id === parseInt(this.dataset.secondGiftId, 10)) {
          secondGiftFlag = true;
          secondGiftKey = item.key;
        }

        if (this.dataset.thirdGiftId && item.variant_id === parseInt(this.dataset.thirdGiftId, 10)) {
          thirdGiftFlag = true;
          thirdGiftKey = item.key;
        }
      });

      // Gift logic based on quantity
      if (nonFreebieCount >= 4) {
        // Add all three gifts
        let itemsToAdd = [];

        if (!firstGiftFlag && this.dataset.firstGiftId) {
          itemsToAdd.push({
            id: parseInt(this.dataset.firstGiftId, 10),
            quantity: 1,
          });
        }

        if (!secondGiftFlag && this.dataset.secondGiftId) {
          itemsToAdd.push({
            id: parseInt(this.dataset.secondGiftId, 10),
            quantity: 1,
          });
        }

        if (!thirdGiftFlag && this.dataset.thirdGiftId) {
          itemsToAdd.push({
            id: parseInt(this.dataset.thirdGiftId, 10),
            quantity: 1,
          });
        }

        if (itemsToAdd.length > 0) {
          updateParsedState = this.processRequest("add", itemsToAdd);
          giftChanged = true;
        }

      } else if (nonFreebieCount >= 3) {
        // Add first two gifts, remove third if exists
        let itemsToAdd = [];

        if (!firstGiftFlag && this.dataset.firstGiftId) {
          itemsToAdd.push({
            id: parseInt(this.dataset.firstGiftId, 10),
            quantity: 1,
          });
        }

        if (!secondGiftFlag && this.dataset.secondGiftId) {
          itemsToAdd.push({
            id: parseInt(this.dataset.secondGiftId, 10),
            quantity: 1,
          });
        }

        if (itemsToAdd.length > 0) {
          updateParsedState = this.processRequest("add", itemsToAdd);
          giftChanged = true;
        }

        // Remove third gift if it exists
        if (thirdGiftFlag && this.dataset.thirdGiftId) {
          updateParsedState = this.processRequest(
            "change",
            parseInt(this.dataset.thirdGiftId, 10),
            thirdGiftKey
          );
          giftChanged = true;
        }

      } else if (nonFreebieCount >= 2) {
        // Add first gift only, remove second and third if they exist
        if (!firstGiftFlag && this.dataset.firstGiftId) {
          let items = [
            {
              id: parseInt(this.dataset.firstGiftId, 10),
              quantity: 1,
            },
          ];

          updateParsedState = this.processRequest("add", items);
          giftChanged = true;
        }

        // Remove second gift if it exists
        if (secondGiftFlag && this.dataset.secondGiftId) {
          updateParsedState = this.processRequest(
            "change",
            parseInt(this.dataset.secondGiftId, 10),
            secondGiftKey
          );
          giftChanged = true;
        }

        // Remove third gift if it exists
        if (thirdGiftFlag && this.dataset.thirdGiftId) {
          updateParsedState = this.processRequest(
            "change",
            parseInt(this.dataset.thirdGiftId, 10),
            thirdGiftKey
          );
          giftChanged = true;
        }

      } else {
        // Remove all gifts if quantity is less than 2
        let updates = {};
        let hasGiftsToRemove = false;

        if (firstGiftFlag && this.dataset.firstGiftId) {
          updates[firstGiftKey] = 0;
          hasGiftsToRemove = true;
        }

        if (secondGiftFlag && this.dataset.secondGiftId) {
          updates[secondGiftKey] = 0;
          hasGiftsToRemove = true;
        }

        if (thirdGiftFlag && this.dataset.thirdGiftId) {
          updates[thirdGiftKey] = 0;
          hasGiftsToRemove = true;
        }

        if (hasGiftsToRemove) {
          updateParsedState = this.processRequest("update", updates);
          giftChanged = true;
        }
      }

      if (!giftChanged) {
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        // Hide gift overlay loader when no gifts changed
        if (giftOverlay) {
          giftOverlay.classList.add("hidden");
        }
      } else {
        // Wait for gift processing to complete
        const giftResult = await updateParsedState;
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            giftResult.sections[section.section],
            section.selector
          );
        });
        // Hide gift overlay loader after gift processing is complete
        if (giftOverlay) {
          giftOverlay.classList.add("hidden");
        }
      }
    } catch (error) {
      this.querySelectorAll(".loading__spinner").forEach((overlay) =>
        overlay.classList.add("hidden")
      );
      // Hide gift overlay loader on error
      if (giftOverlay) {
        giftOverlay.classList.add("hidden");
      }
      console.log(error);
    }

    this.disableLoading(line);
  }

  getSectionsToRender() {
    return [
      {
        id: "NewCartDrawer",
        section: "new-cart-drawer",
        selector: ".new-cart-drawer__main",
      },
      {
        id: "NewCartDrawer",
        section: "new-cart-drawer",
        selector: ".new-cart-drawer__heading",
      },
      {
        id: "sticky-view-cart",
        section: "sticky-view-cart",
        selector: ".sticky-view-cart",
      },
    ];
  }

  enableLoading(line) {
    const cartDrawerItems = document.querySelector(
      ".new-cart-drawer__scroll-container"
    );
    cartDrawerItems.classList.add("cart__items--disabled");

    let id = line.split(":");

    const cartItemElements = cartDrawerItems.querySelectorAll(
      `#new-cart-item-${id[0]} .loading__spinner`
    );

    [...cartItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.checkOutContainer = document.querySelector(
      ".new-cart-drawer__checkout-container"
    );

    if (this.checkOutContainer) {
      const buttons = this.checkOutContainer.querySelectorAll("button");
      buttons.forEach((button) => {
        button.disabled = true;
        button.style.cursor = "not-allowed";
      });
    }
  }

  disableLoading(line) {
    const cartDrawerItems = document.querySelector(
      ".new-cart-drawer__scroll-container"
    );
    cartDrawerItems.classList.remove("new-cart-drawer--disabled");

    let id = line.split(":");

    const cartItemElements = cartDrawerItems.querySelectorAll(
      `#new-cart-item-${id[0]} .loading__spinner`
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));

    this.checkOutContainer = document.querySelector(
      ".new-cart-drawer__checkout-container"
    );

    if (this.checkOutContainer) {
      const buttons = this.checkOutContainer.querySelectorAll("button");
      buttons.forEach((button) => {
        button.disabled = false;
        button.style.cursor = "pointer";
      });
    }
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
}

customElements.define("quantity-selector", QuantitySelector);

class VariantSelector extends HTMLElement {
  constructor() {
    super();

    this.selector = this.querySelector(
      ".new-cart-drawer__cart-item-variant-selector"
    );
    this.variantInput = this.querySelector('input[name="variant"]');
    this.variantsObject = JSON.parse(this.dataset.productVariants || "{}");
    this.selectors = this.querySelectorAll("select");

    this.optionOne = this.querySelector(".option-1");
    this.optionTwo = this.querySelector(".option-2");
    this.optionThree = this.querySelector(".option-3");

    this.setSelectedVariantName();

    if (this.dataset.isCartItem === "true") {
      this.selectors.forEach((selector) => {
        selector.addEventListener("change", async () => {
          this.setSelectedVariantName();
          const newVariantId = this.variantsObject[this.selectedVariantName];

          if (!newVariantId) return;

          this.updatePriceDisplay(newVariantId);
          await this.updateCart(
            this.variantInput.value,
            newVariantId,
            this.dataset.quantity
          );
        });
      });
    } else {
      this.selectors.forEach((selector) => {
        selector.addEventListener("change", () => {
          this.setSelectedVariantName();
          const selectedVariantId =
            this.variantsObject[this.selectedVariantName];
          if (selectedVariantId) {
            this.variantInput.value = selectedVariantId;
            this.updatePriceDisplay(selectedVariantId);
          }
        });
      });

      const atcButton = document.querySelector(
        `#similar-product-atc--${this.dataset.loopIndex}`
      );
      if (atcButton) {
        atcButton.addEventListener("click", async () => {
          await this.updateCart(
            false,
            this.variantsObject[this.selectedVariantName],
            1
          );
        });
      }
    }
  }

  setSelectedVariantName() {
    const parts = [];
    if (this.optionOne) parts.push(this.optionOne.value);
    if (this.optionTwo) parts.push(this.optionTwo.value);
    if (this.optionThree) parts.push(this.optionThree.value);
    this.selectedVariantName = parts.join("/");
  }

  updatePriceDisplay(variantId) {
    const variantPrices = JSON.parse(this.dataset.variantPrices || "{}");
    const prices = variantPrices[variantId];
    if (!prices) return;

    const priceContainer = this.closest(
      ".new-cart-drawer__cart-item"
    )?.querySelector(".new-cart-drawer__cart-item-information-price");

    if (!priceContainer) return;

    const compareAt = priceContainer.querySelector(
      ".new-cart-drawer__cart-item-information-price--compare-at"
    );
    const price = priceContainer.querySelector(
      ".new-cart-drawer__cart-item-information-price--discounted"
    );
    const discount = priceContainer.querySelector(
      ".new-cart-drawer__cart-item-information-price--discount"
    );

    if (compareAt) compareAt.textContent = prices.compare_at_price;
    if (price) price.textContent = prices.price;
    if (discount) {
      discount.textContent =
        prices.discount > 0 ? `(${prices.discount}% OFF)` : "";
    }
  }

  // Get gift configuration from the main cart drawer element
  getGiftConfig() {
    const cartDrawer = document.querySelector('new-cart-drawer');
    return {
      firstGiftId: cartDrawer?.dataset.firstGiftId,
      secondGiftId: cartDrawer?.dataset.secondGiftId,
      thirdGiftId: cartDrawer?.dataset.thirdGiftId
    };
  }

  async updateCart(oldId, newId, quantity = 1) {
    if (oldId) this.enableLoading(oldId);
    
    // Show gift overlay loader during variant change
    const giftOverlay = document.querySelector(".gift__overlay");
    if (giftOverlay) {
      giftOverlay.classList.remove("hidden");
    }

    try {
      const sections = this.getSectionsToRender().map((s) => s.section);
      const body =
        oldId && oldId !== newId
          ? {
              updates: {
                [oldId]: 0,
                [newId]: parseInt(quantity, 10),
              },
              sections,
              sections_url: window.location.pathname,
            }
          : {
              items: [
                {
                  id: parseInt(newId, 10),
                  quantity: parseInt(quantity, 10),
                },
              ],
              sections,
              sections_url: window.location.pathname,
            };

      const url =
        oldId && oldId !== newId
          ? theme.routes.cartUpdate
          : theme.routes.cartAdd;
      const response = await fetch(url, {
        ...fetchConfig(),
        body: JSON.stringify(body),
      });

      const text = await response.text();
      const outerParsedState = JSON.parse(text);
      let parsedState = await fetch("/cart.js").then((res) => res.json());
      
      this.toggleCartState(parsedState.item_count);

      let giftChanged = false;
      let updateParsedState;

      // Get gift configuration from the main cart drawer
      const giftConfig = this.getGiftConfig();

      if (giftConfig.firstGiftId && giftConfig.secondGiftId) {
        const items = parsedState.items;
        
        // Calculate non-freebie count
        const freebieIds = [
          giftConfig.firstGiftId ? parseInt(giftConfig.firstGiftId, 10) : null,
          giftConfig.secondGiftId ? parseInt(giftConfig.secondGiftId, 10) : null,
          giftConfig.thirdGiftId ? parseInt(giftConfig.thirdGiftId, 10) : null
        ].filter(id => id !== null && !isNaN(id));

        console.log("------------------",freebieIds);

        let nonFreebieCount = 0;
        let firstGiftFlag = false;
        let secondGiftFlag = false;
        let thirdGiftFlag = false;
        let firstGiftKey;
        let secondGiftKey;
        let thirdGiftKey;

        items.forEach((item) => {
          // Count non-freebie items
          if (!freebieIds.includes(item.variant_id)) {
            nonFreebieCount += item.quantity;
          }

          // Check for existing gifts
          if (giftConfig.firstGiftId && item.variant_id === parseInt(giftConfig.firstGiftId, 10)) {
            firstGiftFlag = true;
            firstGiftKey = item.key;
          }
          if (giftConfig.secondGiftId && item.variant_id === parseInt(giftConfig.secondGiftId, 10)) {
            secondGiftFlag = true;
            secondGiftKey = item.key;
          }
          if (giftConfig.thirdGiftId && item.variant_id === parseInt(giftConfig.thirdGiftId, 10)) {
            thirdGiftFlag = true;
            thirdGiftKey = item.key;
          }
        });

        // Gift logic based on count
        if (nonFreebieCount >= 4) {
          // Add all three gifts
          const giftsToAdd = [];
          if (!firstGiftFlag && giftConfig.firstGiftId)
            giftsToAdd.push({ id: parseInt(giftConfig.firstGiftId, 10), quantity: 1 });
          if (!secondGiftFlag && giftConfig.secondGiftId)
            giftsToAdd.push({ id: parseInt(giftConfig.secondGiftId, 10), quantity: 1 });
          if (!thirdGiftFlag && giftConfig.thirdGiftId)
            giftsToAdd.push({ id: parseInt(giftConfig.thirdGiftId, 10), quantity: 1 });
          
          if (giftsToAdd.length) {
            updateParsedState = this.processRequest("add", giftsToAdd);
            giftChanged = true;
          }
        } else if (nonFreebieCount >= 3) {
          // Add first two gifts, remove third
          const giftsToAdd = [];
          if (!firstGiftFlag && giftConfig.firstGiftId)
            giftsToAdd.push({ id: parseInt(giftConfig.firstGiftId, 10), quantity: 1 });
          if (!secondGiftFlag && giftConfig.secondGiftId)
            giftsToAdd.push({ id: parseInt(giftConfig.secondGiftId, 10), quantity: 1 });
          
          if (giftsToAdd.length) {
            updateParsedState = this.processRequest("add", giftsToAdd);
            giftChanged = true;
          }
          
          if (thirdGiftFlag && thirdGiftKey) {
            updateParsedState = this.processRequest("change", null, thirdGiftKey);
            giftChanged = true;
          }
        } else if (nonFreebieCount >= 2) {
          // Add first gift only, remove second and third
          if (!firstGiftFlag && giftConfig.firstGiftId) {
            updateParsedState = this.processRequest("add", [
              { id: parseInt(giftConfig.firstGiftId, 10), quantity: 1 }
            ]);
            giftChanged = true;
          }
          
          const updates = {};
          if (secondGiftFlag && secondGiftKey) updates[secondGiftKey] = 0;
          if (thirdGiftFlag && thirdGiftKey) updates[thirdGiftKey] = 0;
          
          if (Object.keys(updates).length > 0) {
            updateParsedState = this.processRequest("update", updates);
            giftChanged = true;
          }
        } else {
          // Remove all gifts
          const updates = {};
          if (firstGiftFlag && firstGiftKey) updates[firstGiftKey] = 0;
          if (secondGiftFlag && secondGiftKey) updates[secondGiftKey] = 0;
          if (thirdGiftFlag && thirdGiftKey) updates[thirdGiftKey] = 0;
          
          if (Object.keys(updates).length > 0) {
            updateParsedState = this.processRequest("update", updates);
            giftChanged = true;
          }
        }
      }

      if (!giftChanged) {
        this.updateSections(outerParsedState.sections);
        // Hide loader after UI update when no gifts changed
        if (giftOverlay) {
          giftOverlay.classList.add("hidden");
        }
      } else {
        // Wait for gift processing to complete
        const giftResponse = await updateParsedState;
        this.updateSections(giftResponse.sections);
        // Hide loader after UI update when gifts were processed
        if (giftOverlay) {
          giftOverlay.classList.add("hidden");
        }
      }
    } catch (error) {
      console.error("Cart update error:", error);
      // Hide loader on error
      if (giftOverlay) {
        giftOverlay.classList.add("hidden");
      }
    } finally {
      if (oldId) this.disableLoading(oldId);
    }
  }

  updateSections(sections) {
    this.getSectionsToRender().forEach(({ id, section, selector }) => {
      const container = document.getElementById(id);
      const target = container?.querySelector(selector) || container;
      if (target && sections[section]) {
        target.innerHTML = this.getSectionInnerHTML(
          sections[section],
          selector
        );
      }
    });
  }

  async processRequest(type, items, key = null) {
    const sections = this.getSectionsToRender().map((s) => s.section);
    let body, url;

    if (type === "add") {
      body = { items, sections, sections_url: window.location.pathname };
      url = theme.routes.cartAdd;
    } else if (type === "change") {
      body = {
        id: key,
        quantity: 0,
        sections,
        sections_url: window.location.pathname,
      };
      url = theme.routes.cartChange;
    } else if (type === "update") {
      body = {
        updates: items,
        sections,
        sections_url: window.location.pathname,
      };
      url = theme.routes.cartUpdate;
    }

    try {
      console.log(body);
      const response = await fetch(url, {
        ...fetchConfig(),
        body: JSON.stringify(body),
      });
      const text = await response.text();
      return JSON.parse(text);
    } catch (error) {
      console.error("Gift processing error:", error);
      throw error;
    }
  }

  toggleCartState(itemCount) {
    const empty = itemCount === 0;
    document
      .querySelector(".new-cart-drawer")
      ?.classList.toggle("is-empty", empty);
    document.querySelector(".new-cart-drawer__footer")?.classList.toggle(
      "is-empty",
      empty
    );
  }

  getSectionsToRender() {
    return [
      {
        id: "NewCartDrawer",
        section: "new-cart-drawer",
        selector: ".new-cart-drawer__main",
      },
      {
        id: "NewCartDrawer",
        section: "new-cart-drawer",
        selector: ".new-cart-drawer__heading",
      },
      {
        id: "sticky-view-cart",
        section: "sticky-view-cart",
        selector: ".sticky-view-cart",
      },
    ];
  }

  enableLoading(line) {
    const cartDrawer = document.querySelector(
      ".new-cart-drawer__scroll-container"
    );
    cartDrawer?.classList.add("cart__items--disabled");
    const id = line.split(":")[0];
    cartDrawer
      ?.querySelectorAll(`#new-cart-item-${id} .loading__spinner`)
      .forEach((el) => el.classList.remove("hidden"));

    const buttons = document.querySelectorAll(
      ".new-cart-drawer__checkout-container button"
    );
    buttons.forEach((btn) => {
      btn.disabled = true;
      btn.style.cursor = "not-allowed";
    });

    document.activeElement?.blur();
  }

  disableLoading(line) {
    const cartDrawer = document.querySelector(
      ".new-cart-drawer__scroll-container"
    );
    cartDrawer?.classList.remove("cart__items--disabled");
    const id = line.split(":")[0];
    cartDrawer
      ?.querySelectorAll(`#new-cart-item-${id} .loading__spinner`)
      .forEach((el) => el.classList.add("hidden"));

    const buttons = document.querySelectorAll(
      ".new-cart-drawer__checkout-container button"
    );
    buttons.forEach((btn) => {
      btn.disabled = false;
      btn.style.cursor = "pointer";
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return (
      new DOMParser().parseFromString(html, "text/html").querySelector(selector)
        ?.innerHTML || ""
    );
  }
}

customElements.define("variant-selector", VariantSelector);

// class CountDown extends HTMLElement {
//   constructor() {
//     super();
//     this.hours = parseInt(this.getAttribute("data-hrs")) || 0;
//     this.minutes = parseInt(this.getAttribute("data-mins")) || 0;
//     this.seconds = parseInt(this.getAttribute("data-secs")) || 0;
//     this.timer = null;
//   }

//   connectedCallback() {
//     this.render();
//     this.startCountdown();
//   }

//   disconnectedCallback() {
//     clearInterval(this.timer);
//   }

//   startCountdown() {
//     this.timer = setInterval(() => {
//       if (this.hours === 0 && this.minutes === 0 && this.seconds === 0) {
//         clearInterval(this.timer);
//         this.dispatchEvent(new Event("countdown-finished"));
//         return;
//       }
//       if (this.seconds > 0) {
//         this.seconds--;
//       } else {
//         if (this.minutes > 0) {
//           this.minutes--;
//           this.seconds = 59;
//         } else if (this.hours > 0) {
//           this.hours--;
//           this.minutes = 59;
//           this.seconds = 59;
//         }
//       }
//       this.render();
//     }, 1000);
//   }

//   render() {
//     this.innerHTML = `${this.formatTime()}`;
//   }

//   formatTime() {
//     return (
//       `${this.hours.toString().padStart(2, "0")}:` +
//       `${this.minutes.toString().padStart(2, "0")}:` +
//       `${this.seconds.toString().padStart(2, "0")}`
//     );
//   }
// }

// customElements.define("count-down", CountDown);

// class AddToCartButton extends HTMLElement {
//   constructor() {
//     super();

//     this.addEventListener("click", (event) => {
//       event.preventDefault();

//       document.querySelector(".gift__overlay")?.classList.remove("hidden");

//       const spinner = this.querySelector(".loading__spinner");
//       const btnLabel = this.querySelector(".new-cart-drawer__btn-label");

//       spinner?.classList.remove("hidden");
//       btnLabel?.classList.add("hidden");

//       this.checkOutContainer = document.querySelector(
//         ".new-cart-drawer__checkout-container"
//       );

//       if (this.checkOutContainer) {
//         const buttons = this.checkOutContainer.querySelectorAll("button");
//         buttons.forEach((button) => {
//           button.disabled = true;
//           button.style.cursor = "not-allowed";
//         });
//       }

//       document.querySelector("new-cart-drawer")?.updateCart(this.dataset.variantId);
//     });
//   }
// }

// customElements.define("add-to-cart-button", AddToCartButton);